import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { CurrencyService } from 'src/app/entities/currency';
import { CurrencyComponent } from 'src/app/entities/currency';
import { Observable } from 'rxjs';
import { ICurrency } from 'src/app/shared/model/currency.model';
import { Currency } from 'src/app/shared/model/currency.model';
import { UserRouteAccessService } from 'src/app/core';

// @Injectable({ providedIn: 'root' })
// export class CurrencyMySuffixResolve implements Resolve<ICurrency> {
//     constructor(private service: CurrencyService) { }

//     resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//         const id = route.params['id'] ? route.params['id'] : null;
//         if (id) {
//             return this.service.find(id).map((country: HttpResponse<Currency>) => country.body);
//         }
//         return Observable.of(new Currency());
//     }
// }
export const currencyRoute: Routes = [
    {
        path: 'currency',
        component: CurrencyComponent,

        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF', 'AUDIT_USER_STAFF', 'AUDIT_USER'],
            defaultSort: 'id,asc',
            pageTitle: 'Currency'
        },
        canActivate: [UserRouteAccessService]
    }
];
